module Main where

import Common

import App.Route (hrUrlPrefix)
import App.Runtime (stepWidget)
import Concur.React.Run (runWidgetInDom)
import Control.Monad.Logger.Class (debug)
import Control.Monad.Logger.Trans (runLoggerT)
import Data.Log.Formatter.JSON (jsonFormatter)
import Data.Log.Tag (empty)
import Effect.Console as Console
import Error (initSentry, sentryFlag)
import GraphQL (graphqlEndpoint)

main :: Effect Unit
main = do
    Console.log "Application Started"

    let envLogger = do
            debug empty $ "GraphQL endpoint: " <> graphqlEndpoint
            debug empty $ "Sentry is " <> if sentryFlag then "enabled." else "disabled."
            debug empty $ "Url prefix is '" <> hrUrlPrefix <> "'"

    runLoggerT envLogger (Console.log <=< pure <<< jsonFormatter)

    _ <- liftEffect $ if sentryFlag then initSentry else pure unit

    runWidgetInDom "forms-spa" stepWidget
